export type ExamRole = "primary" | "secondary";

export function getExamRole(): ExamRole {
  return new URLSearchParams(window.location.search).get("role") === "secondary"
    ? "secondary"
    : "primary";
}

export function examRoleQuery(role = getExamRole()): string {
  return role === "secondary" ? "?role=secondary" : "";
}
